import { render, staticRenderFns } from "./LanguageList.vue?vue&type=template&id=08b6bbc1"
import script from "./LanguageList.vue?vue&type=script&lang=js"
export * from "./LanguageList.vue?vue&type=script&lang=js"
import style0 from "./LanguageList.vue?vue&type=style&index=0&id=08b6bbc1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports